import { render } from "./AiReportChartTypeSelect.vue?vue&type=template&id=a83cc93c&scoped=true&ts=true"
import script from "./AiReportChartTypeSelect.vue?vue&type=script&lang=ts"
export * from "./AiReportChartTypeSelect.vue?vue&type=script&lang=ts"

import "./AiReportChartTypeSelect.vue?vue&type=style&index=0&id=a83cc93c&scoped=true&lang=css"

import exportComponent from "/builds/vidict/ott-platform/procricket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a83cc93c"]])

export default __exports__